import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { timeout, catchError, map, tap } from 'rxjs/operators';
import { Route } from '../interfaces/route';
import { Trip } from '../interfaces/trip';
import { MessageService } from '../services/message.service';
import { GlobalVariables } from '../common/global-variables';

@Injectable({
  providedIn: 'root'
})
export class TrainsService {

  public realtime:boolean = true;
  private trainviewUrl = 'https://www3.septa.org/api/TrainView/?callback=jsonp_callback1';
  private data: any = [];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,  private messageService: MessageService) { }

  /** GET trains from api */
  get (): Observable<any[]> {

    this.data = this.http.jsonp<any[]>(this.trainviewUrl, 'callback')
    .pipe(
      timeout(GlobalVariables.timeout),
      map ((array: any) => array = this.transform(array)),
      tap (_ => this.log('fetched trains')),
      catchError (this.handleError<Route[]>('get', []))
    );

    return this.data;
  }

    /* GET heroes whose name contains search term */
  searchTrains(term: string): Observable<Trip[]> {
    if (!term.trim()) {
      // if not search term, return empty hero array.
      return of([]);
    }
    return this.http.jsonp<any[]>(this.trainviewUrl, 'callback')
    .pipe(
      map ((array: any) => array = this.search(array, term)),
      tap (_ => this.log('fetched trains')),
      catchError (this.handleError<Route[]>('get', []))
    );
  }

  private transform(reponse: any): any{
    var transformed: any[] = [];
    for(const train of reponse){
      const cars = train.consist.split(",").length;
      var status = train.late == 0 ? 'On-time' : train.late > 0 ? train.late + " mins late" : (train.late * -1) + ' mins early';
      status = train.late > 998 ? 'Canceled' : status;
      transformed.push({
        id: train.trainno,
        route: train.line,
        routeID: this.convertRouteToID(train.line),
        block: train.trainno,
        mode: 'Regional Rail',
        type: train.service,
        origin: train.SOURCE,
        destination: train.dest,
        currentstop: train.currentstop,
        nextstop: train.nextstop,
        delay: train.late,
        status: status,
        vehicle: train.consist,
        cars: cars != 0 ? cars : 1,
        heading: train.heading,
        lat: train.lat,
        lon: train.lon
      });

    }

    return transformed;
  }

  private search(reponse: any, term: string): any{
    var transformed: any[] = [];
    for(const train of reponse){
      const cars = train.consist.split(",").length;
      const status = train.late == 0 ? 'On-time' : train.late > 0 ? train.late + " mins late" : train.late + ' mins early';
      if(this.searchArray(train, term)){
        transformed.push({
          id: train.trainno,
          route: train.line,
          routeID: this.convertRouteToID(train.line),
          block: train.trainno,
          mode: 'Regional Rail',
          type: train.service,
          origin: train.SOURCE,
          destination: train.dest,
          currentstop: train.currentstop,
          nextstop: train.nextstop,
          delay: train.late,
          status: status,
          vehicle: train.consist,
          cars: cars != 0 ? cars : 1,
          heading: train.heading,
          lat: train.lat,
          lon: train.lon
        });
      }
    }

    return transformed;
  }

  private searchArray(array: any, term: string){
    for( let i in array) {
      if(i == 'trainno' || i == 'line'){
        if(array[i].toLowerCase().indexOf(term.toLowerCase()) !== -1){
          return true;
        }
      }
    }

    return false;
  }

  private convertRouteToID(name: string): string{
    const prefixRail = ''

    switch(name){
      case 'Airport':
        name = prefixRail + 'AIR';
        break;
      case 'Chestnut Hill East':
        name = prefixRail + 'CHE';
        break;
      case 'Chestnut Hill West':
        name = prefixRail + 'CHW';
        break;
      case 'Cynwyd':
        name = prefixRail + 'CYN';
        break;
      case 'Fox Chase':
        name = prefixRail + 'FOX';
        break;
      case 'Glenside Combined':
        name = prefixRail + 'gc';
        break;
      case 'Lansdale/Doylestown':
        name = prefixRail + 'DOY';
        break;
      case 'Manayunk/Norristown':
        name = prefixRail + 'NOR';
        break;
      case 'Media/Wawa':
        name = prefixRail + 'MED';
        break;
      case 'Paoli/Thorndale':
        name = prefixRail + 'PAO';
        break;
      case 'Trenton':
        name = prefixRail + 'TRE';
        break;
      case 'Warminster':
        name = prefixRail + 'WAR';
        break;
      case 'Wilmington/Newark':
        name = prefixRail + 'WIL';
        break;
      case 'West Trenton':
        name = prefixRail + 'WTR';
        break;

    }

    console.log(name)

    return name;
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      //Mark relatime as false to display the error message.
      this.realtime = false;

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a RouteService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`RouteService: ${message}`);
  }
}
